// No direct PHP counterpart.
// Shared JS helper for:
// - api/fuel/app/classes/controller/api/monty/hindex/create.php
// - api/fuel/app/classes/controller/api/monty/hindex/track.php
// - api/fuel/app/classes/controller/api/monty/hindex/untrack.php
// - api/fuel/app/classes/controller/api/monty/hindex/update.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Util from 'offline/util'
import User from 'offline/model/user'
import HindexTrack from 'offline/model/hindex/track'

function json(data) {
	return {
		session: { offline: true },
		data: data
	}
}

export function ok(data) {
	return Promise.resolve(json(data))
}

export function persist(data) {
	return DB.save().then(function() {
		return json(data)
	})
}

export function invalid(code) {
	return Promise.reject({ error: code || Constants.API_ERROR_INVALID, offline: true })
}

export function currentUser(params) {
	var userId = Number(params.sessionUserId || DB.meta('sync_user_id') || 0) || 0
	return userId ? User.with_id(userId) : null
}

export function hydrateUsersCount(type) {
	if (!type) return 0
	var users = parseInt(DB.scalar(
		'SELECT COUNT(*) FROM hindex_track WHERE hindex_id = ? AND track_hindex > 0',
		[type.get_id()]
	), 10) || 0
	return users
}

export function typeJson(type) {
	var data = type.to_json()
	data.users = hydrateUsersCount(type)
	return data
}

export function trackingIndex(userId) {
	return HindexTrack.indexed('hindex_id', {
		where: {
			user_id: userId
		}
	})
}

export function trackingList(userId) {
	if (!userId) return []
	return HindexTrack.where([
		['hindex_id', '<>', 1],
		['user_id', '=', userId]
	]).map(function(track) {
		return track.to_json()
	})
}

export function hindexSummary(user) {
	return {
		limit: user.get_upgrade() ? 11 : 4,
		added: parseInt(user.get_count_hindex_added() || 0, 10),
		remaining: (user.get_upgrade() ? 11 : 4) - (parseInt(user.get_count_hindex_added() || 0, 10)),
		tracking: trackingList(user.get_id())
	}
}

export function payload(user, type) {
	var freshUser = User.with_id(user.get_id()) || user
	return {
		tracking: trackingIndex(freshUser.get_id()),
		index: typeJson(type),
		hindex: hindexSummary(freshUser)
	}
}

export function ensureUniqueSlug(name, isPublic, userId, excludeId) {
	var base = Util.slug(name || '') || 'index'
	var slug = base
	var index = 1
	var checking = true

	while (checking) {
		var sql = 'SELECT hindex_id FROM hindex_type WHERE hindex_slug = ? AND ' +
			((isPublic) ? 'hindex_public = 1' : 'user_id = ?')
		var params = [slug]

		if (!isPublic) params.push(userId)
		if (excludeId) {
			sql += ' AND hindex_id <> ?'
			params.push(excludeId)
		}

		if (!DB.query(sql, params).length) {
			checking = false
		} else {
			slug = base + '-' + index
			index++
		}
	}

	return slug
}
